import React, { PureComponent } from 'react';
import { Formik, Form, Field } from 'formik';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { initiateMessaging } from '../../dashboard/actions';

import { ContactFormSchema } from '../validation';
import { hideActiveModal, openActiveModal } from './ratingForm';
import { LoginPrompt } from '../../listings/email-options-modal';

const mapStateToProps = state => ({
  admin: state.Global,
  booking: state.Booking
});

class ContactForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        userId: props.values.contactUser ? props.values.contactUser._id : '',
        listingId: props.values.listingId,
        bookingId: props.values.bookingId,
        message: ''
      },
      contactUser: this.props.values.contactUser,
    }
    this.submitForm = this.submitForm.bind(this);
    this.openActiveModal = this.openActiveModal.bind(this);
    this.hideActiveModal = this.hideActiveModal.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
  }

  componentWillUnmount() {
    this.hideActiveModal();
    window.removeEventListener('click', this.clickHandler);
  }

  componentDidMount() {
    this.openActiveModal();
    setTimeout(() => window.addEventListener('click', this.clickHandler), 500);
  }

  openActiveModal = () => {
    openActiveModal('contactModal');
  }

  hideActiveModal = () => {
    hideActiveModal(this.props)
  }

  clickHandler({ target }) {
    if (document.getElementsByClassName('modal-content')[0].contains(target)) {
      //Nothing needs to be done
    } else {
      this.hideActiveModal();
    }
  }

  submitForm(values, { resetForm }) {
    let { dispatch, onSubmit } = this.props;
    dispatch(initiateMessaging(values));
    resetForm(this.state.initialValues);
    this.hideActiveModal();

    if (!!onSubmit)
      onSubmit();
  }

  render() {
    let { admin } = this.props;
    if (!admin.userId) {
      return (<LoginPrompt id="contactModal" hideActiveModal={this.hideActiveModal} />)
    }
    let { contactUser } = this.state;

    return (
      <Formik
        initialValues={this.state.initialValues}
        onSubmit={this.submitForm}
        validationSchema={ContactFormSchema}>
        {({ resetForm, errors }) => (
          <Form>
            <div className="modal" id="contactModal" tabIndex="-1">
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Send a message to {contactUser.firstName} {contactUser.lastName.substr(0, 1)}.</h5>
                  </div>
                  <div className="modal-body">
                    <div className="w-100">
                      <Field
                        name="message"
                        component="textarea"
                        className="form-control"
                      />
                    </div>
                    {errors && errors.message && (<div className="error-message w-100 pl-3">Must include a message.</div>)}
                  </div>
                  <div className="modal-footer">
                    <label className="mt-auto mb-auto" onClick={() => {
                      resetForm(this.state.initialValues);
                      hideActiveModal(this.props);
                    }} data-dismiss="modal">Cancel</label>
                    <button className="btn btn-primary" type="submit">Send</button>
                  </div>
                </div>
              </div></div></Form>
        )}</Formik>
    )
  }
}

export default withRouter(connect(mapStateToProps)(ContactForm));
